import { render, staticRenderFns } from "./widget_last_ipos.vue?vue&type=template&id=7c6be319&scoped=true&"
import script from "./widget_last_ipos.vue?vue&type=script&lang=js&"
export * from "./widget_last_ipos.vue?vue&type=script&lang=js&"
import style0 from "./widget_last_ipos.vue?vue&type=style&index=0&id=7c6be319&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6be319",
  null
  
)

export default component.exports